module.exports = __webpack_public_path__ + "img/9788990878618.d7f4c1e2.jpg";